<template>
  <div class="ex-section">
    <div class="bubble text" :style="{ backgroundColor: color }">
      <p class="text">
        {{ bubble }}
      </p>
    </div>
    <div class="line" :style="{ backgroundColor: color }"></div>
    <div class="content" @click="init" :style="{ backgroundColor: color }">
      <slot />
    </div>
    <!-- <audio type="audio/mpeg" controls>
      <source src="../assets/cbl-supersede.mp3" />
    </audio> -->
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  props: {
    bubble: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  },
  mounted() {
    // const AudioContext = window.AudioContext || window.webkitAudioContext;
    // const audioContext = new AudioContext();
    // var analyser = audioContext.createAnalyser();
    // const audioElement = document.querySelector("audio");
    // const track = audioContext.createMediaElementSource(audioElement);
    // const source = audioContext.MediaElementAudioSourceNode(audioElement);
    // source.connect(analyser);
    // track.connect(audioContext.destination);
    // // eslint-disable-next-line no-console
    // console.log(source);
    // audioElement.play();
    // setTimeout(() => {
    //   // eslint-disable-next-line no-console
    //   console.log(track);
    // }, 5000);
    // var audio = document.querySelector("audio");
    // var context = new AudioContext();
    // var src = context.createMediaElementSource(audio);
    // var analyser = context.createAnalyser();
    // src.connect(analyser);
    // analyser.connect(context.destination);
    // analyser.fftSize = 256;
    // var bufferLength = analyser.frequencyBinCount;
    // console.log(bufferLength);
    // var dataArray = new Uint8Array(bufferLength);
    // this.dataArray = dataArray;
    // this.analyser = analyser;
    // console.log(dataArray);
    // this.playSong();
    // var wavesurfer = WaveSurfer.create({
    //   container: "#waveform",
    //   waveColor: "violet",
    //   progressColor: "purple"
    // });
    // wavesurfer.load(cbl);
    // wavesurfer.play();
    // console.log(wavesurfer);
    //   var audio = document.querySelector("audio");
    //   var context = new AudioContext();
    //   var src = context.createMediaElementSource(audio);
    //   var analyser = context.createAnalyser();
    //   src.connect(analyser);
    //   analyser.connect(context.destination);
  },
  methods: {
    init() {
      //   var wavesurfer = WaveSurfer.create({
      //     container: "#waveform",
      //     waveColor: "violet",
      //     progressColor: "purple"
      //   });
      //   wavesurfer.load(cbl);
      //   var analyser = wavesurfer.backend.analyser;
      //   console.log(wavesurfer);
      //   //   var audio = document.querySelector("audio");
      //   //   var context = new AudioContext();
      //   //   var src = context.createMediaElementSource(audio);
      //   //   var analyser = context.createAnalyser();
      //   //   src.connect(analyser);
      //   //   analyser.connect(context.destination);
      //   //   analyser.fftSize = 256;
      //   var bufferLength = analyser.frequencyBinCount;
      //   //   console.log(bufferLength);
      //   var dataArray = new Uint8Array(bufferLength);
      //   this.dataArray = dataArray;
      //   this.analyser = analyser;
      //   this.wavesurfer = wavesurfer;
      //   console.log(dataArray);
      //   var wavesurfer = WaveSurfer.create({
      //     container: "#waveform",
      //     waveColor: "violet",
      //     progressColor: "purple"
      //   });
      //   wavesurfer.load(cbl);
      //   wavesurfer.play();
    },
    playSong() {
      //   setTimeout(() => {
      //     this.playSong();
      //   }, 15);
    }
  }
};
</script>

<style lang="scss" scoped>
.ex-section {
  position: relative;
  overflow: hidden;
  .bubble {
    background-color: $color-darkergreen;
    color: white;
    max-width: 500px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 10px;
    text-align: center;
  }

  .line {
    width: 5px;
    height: 30px;
    background-color: $color-darkergreen;
    margin: 0 auto;
  }

  .content {
    padding: 20px;
    background-color: $color-darkergreen;
  }
}
</style>
